export const CONTACT_PREFERENCES = "ContactPreferences";
export const MY_ACCOUNT = "MyAccount";
export const MY_ACCOUNT_CRISTMAS_LOGGEDIN = "MyAccountChristmasLoggedIn";
export const MY_ACCOUNT_CRISTMAS_LOGGEDOUT = "MyAccountChristmasLoggedOut";
export const MY_ACCOUNT_EASTER_LOGGEDIN = "MyAccountEasterLoggedIn";
export const MY_ACCOUNT_EASTER_LOGGEDOUT = "MyAccountEasterLoggedOut";
export const MY_ACCOUNT_STPATRICKS_LOGGEDIN = "MyAccountStPatricksLoggedIn";
export const MY_ACCOUNT_STPATRICKS_LOGGEDOUT = "MyAccountStPatricksLoggedOut";
export const MY_ORDERS = "MyOrders";
export const RETURNS_INFORMATION = "ReturnsInformation";
